import { Component, OnDestroy, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { NotificationsService, UserNotification } from './notifications.service';

@Component({
	selector: 'app-navbar-notification',
	templateUrl: './navbar-notification.component.html',
	styleUrls: ['./navbar-notification.component.scss'],
	changeDetection: ChangeDetectionStrategy.Eager,
	standalone: false,
})
export class NavbarNotificationComponent implements OnInit, OnDestroy {
	notifications: UserNotification[] = [];
	unreadCount = 0;

	private _unsubscribeAll = new Subject<void>();

	constructor(
		private _notificationsService: NotificationsService,
		private _router: Router,
		private _translateService: TranslateService
	) {}

	ngOnInit(): void {
		this._notificationsService.notifications$.pipe(takeUntil(this._unsubscribeAll)).subscribe(n => (this.notifications = n));

		this._notificationsService.unreadCount$.pipe(takeUntil(this._unsubscribeAll)).subscribe(c => (this.unreadCount = c));

		this._notificationsService.connect();
	}

	markAllRead(): void {
		this._notificationsService.markAllRead().pipe(takeUntil(this._unsubscribeAll)).subscribe();
	}

	markRead(id: string, readAt: string | null): void {
		if (readAt) return;
		this._notificationsService.markRead(id).pipe(takeUntil(this._unsubscribeAll)).subscribe();
	}

	typeIcon(type: string): string {
		const icons: Record<string, string> = {
			success: 'check-circle',
			warning: 'alert-triangle',
			error: 'x-circle',
			info: 'info',
		};
		return icons[type] ?? 'bell';
	}

	typeClass(type: string): string {
		const classes: Record<string, string> = {
			success: 'bg-light-success',
			warning: 'bg-light-warning',
			error: 'bg-light-danger',
			info: 'bg-light-primary',
		};
		return classes[type] ?? 'bg-light-primary';
	}

	deleteNotification(id: string, event: MouseEvent): void {
		event.stopPropagation();
		this._notificationsService.deleteNotification(id).pipe(takeUntil(this._unsubscribeAll)).subscribe();
	}

	localizeBody(body?: string | null): string {
		return this._notificationsService.localizeBody(body);
	}

	goToAllNotifications(): void {
		this._router.navigate(['/my-notifications']);
	}

	ngOnDestroy(): void {
		this._unsubscribeAll.next();
		this._unsubscribeAll.complete();
		this._notificationsService.disconnect();
	}
}
